import { ApplicationResourceType } from '@flowx/designer/shared/entities/application.entity'

import { createDataModelEffects } from './data-model.effects'

import { TemplateDataModelApiService } from '../../api/template-data-model.api'
import { DocumentTemplateDataModelActions } from '../actions/template-data-model.actions'

const documentTemplateDataModelBasicEffects = createDataModelEffects(
  ApplicationResourceType.DocumentTemplate,
  {
    load: DocumentTemplateDataModelActions.loadEntities,
    loadSuccess: DocumentTemplateDataModelActions.loadEntitiesSuccess,
    loadFailure: DocumentTemplateDataModelActions.loadEntitiesFailure,
    add: DocumentTemplateDataModelActions.addEntity,
    addSuccess: DocumentTemplateDataModelActions.addEntitySuccess,
    addFailure: DocumentTemplateDataModelActions.addEntityFailure,
    edit: DocumentTemplateDataModelActions.editEntity,
    editSuccess: DocumentTemplateDataModelActions.editEntitySuccess,
    editFailure: DocumentTemplateDataModelActions.editEntityFailure,
    addAttribute: DocumentTemplateDataModelActions.addAttribute,
    addAttributeSuccess: DocumentTemplateDataModelActions.addAttributeSuccess,
    addAttributeFailure: DocumentTemplateDataModelActions.addAttributeFailure,
    editAttribute: DocumentTemplateDataModelActions.editAttribute,
    editAttributeSuccess: DocumentTemplateDataModelActions.editAttributeSuccess,
    editAttributeFailure: DocumentTemplateDataModelActions.editAttributeFailure,
    requestDeleteEntity: DocumentTemplateDataModelActions.deleteEntityRequested,
    deleteEntity: DocumentTemplateDataModelActions.deleteEntity,
    deleteEntitySuccess: DocumentTemplateDataModelActions.deleteEntitySuccess,
    deleteEntityFailure: DocumentTemplateDataModelActions.deleteEntityFailure,
    requestDeleteAttribute: DocumentTemplateDataModelActions.deleteAttributeRequested,
    deleteAttribute: DocumentTemplateDataModelActions.deleteAttribute,
    deleteAttributeSuccess: DocumentTemplateDataModelActions.deleteAttributeSuccess,
    deleteAttributeFailure: DocumentTemplateDataModelActions.deleteAttributeFailure,
    resetErrors: DocumentTemplateDataModelActions.resetErrors,
    resetErrorsSuccess: DocumentTemplateDataModelActions.resetErrorsSuccess,
    updateAttributeValidators: DocumentTemplateDataModelActions.updateAttributeValidators,
    updateAttributeValidatorsSuccess:
      DocumentTemplateDataModelActions.updateAttributeValidatorsSuccess,
    updateAttributeValidatorsFailure:
      DocumentTemplateDataModelActions.updateAttributeValidatorsFailure,
  },
  TemplateDataModelApiService
)

export const documentTemplateAddEntity$ = documentTemplateDataModelBasicEffects.addEntity$
export const documentTemplateEditEntity$ = documentTemplateDataModelBasicEffects.editEntity$
export const documentTemplateAddAttribute$ = documentTemplateDataModelBasicEffects.addAttribute$
export const documentTemplateEditAttribute$ = documentTemplateDataModelBasicEffects.editAttribute$
export const documentTemplateSetNewEntityAsAttribute$ =
  documentTemplateDataModelBasicEffects.setNewEntityAsAttribute$
export const documentTemplateStartDeleteEntity$ =
  documentTemplateDataModelBasicEffects.startDeleteEntity$
export const documentTemplateDeleteEntity$ = documentTemplateDataModelBasicEffects.deleteEntity$
export const documentTemplateStartDeleteAttribute$ =
  documentTemplateDataModelBasicEffects.startDeleteAttribute$
export const documentTemplateDeleteAttribute$ =
  documentTemplateDataModelBasicEffects.deleteAttribute$
export const documentTemplateResetErrors$ = documentTemplateDataModelBasicEffects.resetErrors$
export const documentTemplateUpdateAttributeValidators$ =
  documentTemplateDataModelBasicEffects.updateAttributeValidators$
